import {
    ITipsFeedbackFilters,
    ITipsFeedbackItem,
    TFeedbackWorkflowStatus,
} from '../../../interfaces/tips-feedback/ITipsFeedback';

export const FEEDBACK_STATUSES: { value: TFeedbackWorkflowStatus; label: string }[] = [
    { value: 'submitted', label: 'Submitted' },
    { value: 'investigating', label: 'Leo is Investigating' },
    { value: 'resolved', label: 'Resolved' },
    { value: 'regenerated', label: 'Regenerated' },
    { value: 'actioned', label: 'Actioned' },
    { value: 'cannot_resolve', label: 'Cannot Resolve' },
];

// Billy groups the stored workflow states into these three dashboard statuses.
export const FEEDBACK_FILTER_STATUSES = FEEDBACK_STATUSES.filter((status) =>
    ['investigating', 'resolved', 'cannot_resolve'].includes(status.value));

export const canManageFeedback = (status?: string) =>
    status === 'submitted' || status === 'investigating';

export const canResolveFeedback = (item: ITipsFeedbackItem) =>
    Boolean(item.tipId) && (
        canManageFeedback(item.workflowStatus)
        || (item.workflowStatus === 'resolved' && !item.replacementTipId)
    );

export const feedbackStatusLabel = (status?: string, label?: string) =>
    label || FEEDBACK_STATUSES.find((option) => option.value === status)?.label
    || status?.replace(/_/g, ' ')
    || 'Not set';

export const sanitizeFeedbackFilters = (filters: ITipsFeedbackFilters): ITipsFeedbackFilters => ({
    ...(filters.search?.trim() ? { search: filters.search.trim() } : {}),
    ...(filters.client?.trim() ? { client: filters.client.trim() } : {}),
    ...(filters.property?.trim() ? { property: filters.property.trim() } : {}),
    ...(filters.dateFrom ? { dateFrom: filters.dateFrom } : {}),
    ...(filters.dateTo ? { dateTo: filters.dateTo } : {}),
    ...(filters.workflowStatus ? { workflowStatus: filters.workflowStatus } : {}),
});

export const feedbackErrorMessage = (error: unknown, fallback: string): string => {
    const payload = error as { data?: { message?: unknown; error?: unknown }; message?: unknown };
    const message = payload?.data?.message || payload?.data?.error || payload?.message;
    if (typeof message === 'string') return message;
    if (Array.isArray(message) && message.every((entry) => typeof entry === 'string')) return message.join(' ');
    return fallback;
};
